import { createFileRoute } from '@tanstack/react-router'
import { RoleEditorPage } from '@/features/authorization/index.ts'

export const Route = createFileRoute('/_authenticated/system-management/roles/new')({
  component: () => <RoleEditorPage />
})
